import { render, staticRenderFns } from "./addPageModal.vue?vue&type=template&id=de9e12a6&"
import script from "./addPageModal.vue?vue&type=script&lang=ts&"
export * from "./addPageModal.vue?vue&type=script&lang=ts&"
import style0 from "./addPageModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports